import AbstractCommand from "../../../core/application/AbstractCommand";

export default class EmailAvailableCommand extends AbstractCommand {
    constructor(dispatcher, emailModel) {
        super(dispatcher);

        this.emailModel = emailModel;
    }

    execute(event) {
        const content = event.params.data.content;
        const contentPlayer = event.params.data.contentPlayer;

        this.emailModel.addEmail(content);
        contentPlayer.contentCompleted(content);
    }
}